exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".note-modal .header-editior .editor-menu-bar {\n  margin-left: 0.5px;\n  margin-right: 0px;\n}", ""]);

// exports
